import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ff_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiErr(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

function detectPlatform() {
  const ua = navigator.userAgent || "";
  if (/Mobi|Android|iPhone|iPod/i.test(ua)) return "mobile";
  if (/iPad|Tablet/i.test(ua)) return "tablet";
  return "desktop";
}

// Fire-and-forget, privacy-safe analytics event (server allowlists names).
export function track(name, ref) {
  try {
    api.post("/analytics/track", { name, platform: detectPlatform(), ref: ref || null }).catch(() => {});
  } catch (e) { /* never block UI */ }
}

export const HERO_MAP =
  "https://static.prod-images.emergentagent.com/jobs/9a3ac3dd-d1f0-422c-8074-8c7405840ede/images/f016f1743b9cf67ef6ea29fe8310d40497b6cd5c4d94b1e631efa01f757fa7a6.jpeg";

// Deprecated aliases kept for backward-compat — prefer importing from ../brand.
export { brandIconSquare as LOGO, brandIconSquare as APP_ICON, brandLogoFull } from "./brand";

export const DISCLAIMER =
  "Aurumward uses virtual in-game currency only. Virtual Gold has no real-world monetary value.";

export default api;
